// extracted by mini-css-extract-plugin
export default {"container_modal":"ModalApps_container_modal__yYuvd","container_caminhos":"ModalApps_container_caminhos__dy2X9"};